import { Component, Input, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

import LoginModel from '../../../../../models/user.model';
import { AppCommon } from '../../../../../providers/app-common';
import { SourcingNeedV2ViewModel } from '../../../../../models-views/sourcing-needs-v2.view.model';
import { StandardResponseModel } from '../../../../../models/project.model';

@Component({
  selector: 'app-sn-form-transport-v2',
  templateUrl: './sn-form-transport-v2.component.html',
  styleUrls: ['./sn-form-transport-v2.component.scss'],
  standalone: false
})
export class SnFormTransportV2Component implements OnInit, OnChanges {
  @Input() eventId: number | null = null;
  @Input() data: any;
  @Output() closeModal = new EventEmitter<'success' | 'cancel'>();
  
  form!: FormGroup;
  isEdit: boolean = true;
  isView: boolean = false;
  existingData: any = null;

  airportTransfersResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
  localVenueTransfersResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
  vehiclesTypesResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());

  constructor(
    private fb: FormBuilder, 
    private vm: SourcingNeedV2ViewModel,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.vm.parentSnFormTransportV2Component = this;
    this.initForm();
    this.vm.subscribeToTrasportModels(
      this.airportTransfersResponseModel,
      this.localVenueTransfersResponseModel,
      this.vehiclesTypesResponseModel
    );
    this.vm.initGeneralCallsForTransport();
    
    setTimeout(() => {
      this.handleInputData();
    }, 300);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && !changes['data'].firstChange) {
      this.handleInputData();
    }
  }

  handleInputData(): void {

    if (this.data) {
      this.existingData = this.data;
      this.isView = false;
      this.isEdit = true;
      this.form.patchValue(this.mapApiToForm(this.data));
    } else {
      this.existingData = null;
      this.isView = false;
      this.isEdit = true;
      this.form.reset();
      this.form.enable();
      this.cdr.detectChanges();
    }
  }

  mapApiToForm(data: any): any {
    // Map API response to form fields - extract IDs from details arrays
    // Handle both plural and singular key variants from API
    return {
      airport_transfers: data.airport_transfers_details?.map((item: any) => item.id) || [],
      local_venue_transfers: data.local_venue_transfers_details?.map((item: any) => item.id) || [],
      vehicles_types: (data.vehicles_types_details || data.vehicles_type_details)?.map((item: any) => item.id) || data.vehicles_types || [],
    };
  }

  initForm(): void {
    this.form = this.fb.group({
      airport_transfers: [[], ],
      local_venue_transfers: [[], ],
      vehicles_types: [[],],
    });
  }

  onSave(): void {
    if (this.form.valid) {
      const payload = this.form.value;
      payload.sourcing_need = this.eventId;
      payload.is_transport_required = true;
      
      const loggedInUser = AppCommon.getloggedInObject();
      const userId = loggedInUser?.user?.id;

      if(payload.airport_transfers === null) {
        payload.airport_transfers = [];
      }

      if(payload.local_venue_transfers === null) {
        payload.local_venue_transfers = [];
      }

      if(payload.vehicles_types === null) {
        payload.vehicles_types = [];
      }
      
      if (this.isEdit && this.existingData) {
        payload.id = this.existingData.id;
        payload.modified_by = userId;
        this.vm.addUpdateSouringTrasport(payload, true);
      } else {
        payload.created_by = userId;
        this.vm.addUpdateSouringTrasport(payload, false);
      }
    }
  }

  sourcingTrasportAdded() {
    this.closeModal.emit('success');
    
    // Refresh parent component data
    if (this.eventId) {
      this.vm.getSouringNeedbyId(this.eventId, 'cet-sourcing-needs-v2');
    }
  }

  onEdit(): void {
    this.isEdit = true;
    this.isView = false;
    this.form.enable();
  }

  onCancel(): void {
    this.closeModal.emit('cancel');
  }
}